import { FastField, FormikProps } from 'formik';
import { ChangeEvent, useState } from 'react';

import { formatCurrency, formatDate } from '@shared/commonFunctions';
import { NumberInputField } from '@shared/fields/NumberInputField';
import { SelectDateField } from '@shared/fields/SelectDateField';
import { NumberInput } from '@shared/inputs/NumberInput';
import { LenderSectionRow } from '@styles/ContactManager/DealCalculator/LenderSectionStyles';
import { DealCalculatorModel } from '../../../../models/DealCalculatorModel';
import { IEligibleLender } from '../../../../models/EligibleLenderModel';
import { addDays, getPayment } from './lernderCalculationUtils';

type ILenderResultProps = {
  lender: IEligibleLender;
  idx: number;
  formProps: FormikProps<DealCalculatorModel>;
  totalAmountFinanced: number;
  netRate: number;
  lienPayment: number;
  dealStatus?: string;
  estimatedRefunds: number;
};

const LenderPitch = ({
  idx,
  formProps,
  totalAmountFinanced,
  netRate,
  lienPayment,
  dealStatus,
  estimatedRefunds,
}: ILenderResultProps) => {
  const {
    values: { eligibleLenders },
  } = formProps;
  const { contractDate, firstPaymentDays } = eligibleLenders[idx].inputs;

  const [varPmt, setVarPmt] = useState(0);

  const rate = netRate / 100;

  return (
    <>
      <LenderSectionRow>
        <b>{formatCurrency(estimatedRefunds)}</b>
      </LenderSectionRow>
      <LenderSectionRow>
        <FastField name={`eligibleLenders[${idx}].inputs.contractDate`} component={SelectDateField} width={'50%'} />
      </LenderSectionRow>
      <LenderSectionRow>
        <FastField name={`eligibleLenders[${idx}].inputs.firstPaymentDays`} component={NumberInputField} limit={4} />
      </LenderSectionRow>
      <LenderSectionRow>{formatDate(addDays(contractDate, firstPaymentDays).toISOString())}</LenderSectionRow>
      <LenderSectionRow>
        <b>{getPayment(lienPayment, totalAmountFinanced, rate)}</b>
      </LenderSectionRow>
      <LenderSectionRow>
        <NumberInput
          prefix="$"
          value={varPmt}
          onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => setVarPmt(Number(value))}
        />
      </LenderSectionRow>
      <LenderSectionRow>
        <b>{getPayment(varPmt, totalAmountFinanced, rate)}</b>
      </LenderSectionRow>
      <LenderSectionRow>{dealStatus}</LenderSectionRow>
    </>
  );
};

export default LenderPitch;
